export var postInputWidth = 'var(--o9ay5w1)';
export var preInputWidth = 'var(--o9ay5w0)';
export var transitionTime = '250ms';
export var visibleLines = 'var(--o9ay5w2)';